/* eslint-disable no-return-assign */
import {
  Environment,
  Network,
  QueryResponseCache,
  RecordSource,
  Store,
} from 'relay-runtime';
import cookie from '@/helpers/cookie.js';
import getLocale from '@/helpers/locale.js';
import { timeoutSignal } from '@/helpers/fetchTimeout.js';

const oneMinute = 5 * 60 * 1000;
const cache = new QueryResponseCache({ size: 250, ttl: oneMinute });
const FETCH_TIMEOUT_MS = 60 * 1000;
// let environment = null;

// eslint-disable-next-line default-param-last
async function fetchServerQL(text, paramsvariables = {}, token, serverLocale) {
  const headers = {};
  if (token) {
    headers.authorization = `Bearer ${token}`;
  }

  const { actAsUser, ...variables } = paramsvariables || {};
  if (actAsUser) {
    headers['x-act-as-user'] = actAsUser;
  }
  headers['x-locale'] = getLocale(serverLocale);

  const response = await fetch(process.env.NEXT_PUBLIC_API_GRAPHQL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-client-name': 'web-private',
      'x-client-version': `1.0-${process.env.NEXT_PUBLIC_CLIENT_CUSTOM_VERSION}`,
      ...headers,
    },
    body: JSON.stringify({
      query: text,
      variables,
    }),
    signal: timeoutSignal(FETCH_TIMEOUT_MS),
  });

  return response.json();
}

function createFetchQuery(serverToken, serverLocale) {
  return function fetchQuery(operation, paramsvariables, cacheConfig) {
    const { actAsUser, ...variables } = paramsvariables || {};

    const queryID = operation.text;
    const isMutation = operation.operationKind === 'mutation';
    const isQuery = operation.operationKind === 'query';
    const forceFetch = cacheConfig && cacheConfig.force;
    const fromCache = cache.get(queryID, variables);
    const noCache = cacheConfig && cacheConfig.noCache;

    if (isQuery && fromCache !== null && !forceFetch) {
      return fromCache;
    }
    const headers = {
      'Content-Type': 'application/json',
      'x-client-name': 'webapp',
      'x-client-version': 'v3@Tom',
      'x-locale': getLocale(serverLocale),
    };
    const token = serverToken ?? (() => {
      try {
        return cookie.getTokenConnection();
      } catch (e) {
        console.log(e);
        return null;
      }
    })();
    if (token) {
      headers.authorization = `Bearer ${token}`;
    }

    if (actAsUser) {
      headers['x-act-as-user'] = actAsUser;
    }

    return fetch(
      process.env.NEXT_PUBLIC_API_GRAPHQL,
      {
        method: 'POST',
        headers,
        body: JSON.stringify({
          query: operation.text,
          variables,
        }),
        cache: 'no-store',
        signal: timeoutSignal(FETCH_TIMEOUT_MS),
      },
    )
      .then((response) => response.json())
      .then((json) => {
        if (isQuery && json && !noCache) {
          cache.set(queryID, variables, json);
        }
        if (isMutation) {
          cache.clear();
        }

        return json;
      }).catch((e) => {
        console.log(e);
        throw new Error(`graphql fetch failed: ${e?.message || e}`);
      });
  };
}

let currentEnvironment;
const initEnvironment = ({
 records = {}, keepStore = false, token, locale,
} = {}) => { // eslint-disable-line max-len, import/prefer-default-export
  let newRecords = records;
  if (!records || !Object.entries(records).length) newRecords = {};
  const network = Network.create(createFetchQuery(token, locale));
  const store = new Store(new RecordSource(newRecords));

  if (keepStore && currentEnvironment) {
    return currentEnvironment;
  }

  currentEnvironment = new Environment({
    network,
    store,
  });

  return currentEnvironment;
};

const cleanEnvironment = () => {}; // currentEnvironment = null;
export { initEnvironment, fetchServerQL, cleanEnvironment };
export default initEnvironment;
